import React, { useState } from 'react';
import { FiDownload } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { usePWA } from '../../hooks/usePWA';
import { InstallPromptContainer } from './styles';
import Btn from '../Buttons/Btn';

const InstallPromptModal: React.FC = () => {
  const { t } = useTranslation();
  const { shouldShowInstallModal, promptInstall, dismissInstallPrompt, neverShowAgain } = usePWA();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  if (!shouldShowInstallModal) return null;

  const handleInstall = async () => {
    await promptInstall();
    dismissInstallPrompt();
  };

  const handleDismiss = () => {
    if (dontShowAgain) {
      neverShowAgain();
    } else {
      dismissInstallPrompt();
    }
  };

  return (
    <InstallPromptContainer>
      <div className="overlay" onClick={handleDismiss} />
      <div className="modal">
        <div className="icon-container">
          <FiDownload size={28} />
        </div>

        <h2 className="title">{t('installAppTitle')}</h2>
        <p className="description">
          {t('installAppDescription')}
        </p>

        <div className="button-group">
          <Btn
            Icon={FiDownload}
            text={t('install')}
            type="contained"
            onClick={() => handleInstall()}
          />
          <Btn
            text={t('notNow')}
            type="text"
            onClick={() => handleDismiss()}
          />
        </div>

        <label className="checkbox-wrapper">
          <input
            type="checkbox"
            className="checkbox"
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          />
          <span className="checkbox-label">{t('dontShowAgain')}</span>
        </label>
      </div>
    </InstallPromptContainer>
  );
};

export default InstallPromptModal;
